import { useTranslation } from 'react-i18next';
import { TopBanner } from '@aqarmap/aqarmap-ui';

export default function SaudiTopBanner() {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  return (
    <TopBanner
      id="saudi-top-banner"
      isClosable={true}
      className="bg-green_dark  h-auto top-banner flex"
    >
      <a
        href={
          locale === 'ar'
            ? 'https://aqarmap.sa/fos/ar.html'
            : 'https://aqarmap.sa/fos/'
        }
        className="flex justify-center items-center text-gray_light_1 w-full"
      >
        {t('saudiBannerText')}
      </a>
    </TopBanner>
  );
}
